import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object({
  newPassword: Yup.string()
    .required("resetPassword.block-form.error.newPassword-required")
    .min(10, "10 digits")
    .matches(RegExp("(.*[a-z].*)"), "Lowercase")
    .matches(RegExp("(.*[A-Z].*)"), "Uppercase")
    .matches(RegExp("(.*\\d.*)"), "Number")
    .matches(RegExp('[!@#$%^&*(),.?":{}|<>]'), "Special"),
  confirmPassword: Yup.string()
    .required("resetPassword.block-form.error.confirmPassword-required")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "resetPassword.block-form.error.incorrect-newPassword"
    )
});
